// import React, { useEffect, useState } from "react";
// // import { supabase } from "../../../supabaseClient";
// import supabase from "../../../supabaseClient";
// import { FiTrash2, FiEdit } from "react-icons/fi";

// export default function BlogsCMS() {
//   const [blogs, setBlogs] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [editingId, setEditingId] = useState(null);

//   const [title, setTitle] = useState("");
//   const [slug, setSlug] = useState("");
//   const [content, setContent] = useState("");
//   const [bannerFile, setBannerFile] = useState(null);

//   const fetchBlogs = async () => {
//     const { data } = await supabase.from("blogs").select("*").order("created_at", { ascending: false });
//     setBlogs(data || []);
//   };

//   useEffect(() => {
//     fetchBlogs();
//   }, []);

//   const handleImageUpload = async () => {
//     if (!bannerFile) return null;
//     const filename = `blog-${Date.now()}-${bannerFile.name}`;
//     const { data, error } = await supabase.storage.from("blogs").upload(filename, bannerFile);
//     if (error) return null;
//     return supabase.storage.from("blogs").getPublicUrl(filename).data.publicUrl;
//   };

//   const handleSave = async () => {
//     const banner_url = await handleImageUpload();

//     const payload = {
//       title,
//       slug,
//       content,
//       ...(banner_url && { banner_url }),
//     };

//     let result;

//     if (editingId) {
//       result = await supabase.from("blogs").update(payload).eq("id", editingId);
//     } else {
//       result = await supabase.from("blogs").insert([payload]);
//     }

//     if (result.error) console.error(result.error);

//     resetForm();
//     fetchBlogs();
//   };

//   const handleEdit = (blog) => {
//     setEditingId(blog.id);
//     setTitle(blog.title);
//     setSlug(blog.slug);
//     setContent(blog.content);
//     setBannerFile(null);
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this blog?")) return;
//     const { error } = await supabase.from("blogs").delete().eq("id", id);
//     if (!error) fetchBlogs();
//   };

//   const resetForm = () => {
//     setTitle("");
//     setSlug("");
//     setContent("");
//     setBannerFile(null);
//     setEditingId(null);
//     setShowModal(false);
//   };

//   return (
//     <div className="p-4">
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="text-xl font-bold">Blogs Manager</h2>
//         <button
//           onClick={() => setShowModal(true)}
//           className="bg-green-600 text-white px-4 py-2 rounded"
//         >
//           + Add Blog
//         </button>
//       </div>

//       <table className="w-full border text-sm">
//         <thead className="bg-gray-100">
//           <tr>
//             <th className="p-2">Banner</th>
//             <th className="p-2">Title</th>
//             <th className="p-2">Slug</th>
//             <th className="p-2">Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {blogs.length > 0 ? (
//             blogs.map((blog) => (
//               <tr key={blog.id} className="text-center border-b">
//                 <td className="p-2">
//                   {blog.banner_url && (
//                     <img src={blog.banner_url} className="w-20 h-12 object-cover mx-auto rounded" alt="" />
//                   )}
//                 </td>
//                 <td className="p-2">{blog.title}</td>
//                 <td className="p-2">{blog.slug}</td>
//                 <td className="p-2 flex justify-center gap-4">
//                   <button onClick={() => handleEdit(blog)} className="text-blue-600">
//                     <FiEdit />
//                   </button>
//                   <button onClick={() => handleDelete(blog.id)} className="text-red-600">
//                     <FiTrash2 />
//                   </button>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td className="p-4 text-center" colSpan="4">No Blogs Added Yet</td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       {/* Modal */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center">
//           <div className="bg-white p-6 w-[500px] rounded shadow-lg">
//             <h3 className="text-lg font-bold mb-3">{editingId ? "Edit Blog" : "Add Blog"}</h3>

//             <input type="text" placeholder="Title" className="w-full border p-2 mb-2" value={title} onChange={(e)=>setTitle(e.target.value)} />
//             <input type="text" placeholder="Slug" className="w-full border p-2 mb-2" value={slug} onChange={(e)=>setSlug(e.target.value)} />
//             <textarea placeholder="Content" className="w-full border p-2 h-32 mb-3" value={content} onChange={(e)=>setContent(e.target.value)} />

//             <input type="file" onChange={(e)=>setBannerFile(e.target.files[0])} className="mb-3" />

//             <div className="flex justify-end gap-3">
//               <button onClick={resetForm} className="px-4 py-2 border rounded">Cancel</button>
//               <button onClick={handleSave} className="bg-green-600 text-white px-4 py-2 rounded">
//                 {editingId ? "Update" : "Save"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import supabase from "../../../supabaseClient";
import { FiTrash2, FiEdit } from "react-icons/fi";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Image from "@tiptap/extension-image";

export default function BlogsCMS() {
  const [blogs, setBlogs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [bannerFile, setBannerFile] = useState(null);

  const fetchBlogs = async () => {
    const { data } = await supabase.from("blogs").select("*").order("created_at", { ascending: false });
    setBlogs(data || []);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  // Auto slug from title
  useEffect(() => {
    setSlug(title.toLowerCase().replace(/ /g, "-"));
  }, [title]);

  const editor = useEditor({
    extensions: [
      StarterKit,
      Image,
    ],
    content: "",
  });

  // Insert image into blog body
  const addImage = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      const filename = `blog-${Date.now()}-${file.name}`;

      const { error } = await supabase.storage.from("blogs").upload(filename, file);

      if (!error) {
        const url = supabase.storage.from("blogs").getPublicUrl(filename).data.publicUrl;
        editor.chain().focus().setImage({ src: url }).run();
      }
    };
  };

  const uploadBanner = async () => {
    if (!bannerFile) return null;
    const filename = `banner-${Date.now()}-${bannerFile.name}`;
    const { error } = await supabase.storage.from("blogs").upload(filename, bannerFile);

    if (!error) {
      return supabase.storage.from("blogs").getPublicUrl(filename).data.publicUrl;
    }
  };

  const handleSave = async () => {
    const contentHtml = editor.getHTML();
    const banner_url = await uploadBanner();

    const payload = {
      title,
      slug,
      content: contentHtml,
      ...(banner_url && { banner_url }),
    };

    if (editingId) {
      await supabase.from("blogs").update(payload).eq("id", editingId);
    } else {
      await supabase.from("blogs").insert([payload]);
    }

    reset();
    fetchBlogs();
  };

  const handleEdit = (blog) => {
    setEditingId(blog.id);
    setTitle(blog.title);
    setSlug(blog.slug);
    editor.commands.setContent(blog.content);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this blog?")) return;
    await supabase.from("blogs").delete().eq("id", id);
    fetchBlogs();
  };

  const reset = () => {
    setTitle("");
    setSlug("");
    editor.commands.setContent("");
    setBannerFile(null);
    setEditingId(null);
    setShowModal(false);
  };

  return (
    <div className="p-4">
      <div className="flex justify-between mb-4">
        <h2 className="text-xl font-bold">Blogs Manager</h2>
        <button className="bg-green-600 text-white px-4 py-2 rounded" onClick={() => setShowModal(true)}>
          + Add Blog
        </button>
      </div>

      <table className="border w-full text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2">Banner</th>
            <th className="p-2">Title</th>
            <th className="p-2">Slug</th>
            <th className="p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {blogs.map((blog) => (
            <tr key={blog.id} className="text-center border">
              <td className="p-2">{blog.banner_url && <img className="w-20 h-12 mx-auto object-cover rounded" src={blog.banner_url} alt={blog.title || "Blog banner"} />}</td>
              <td className="p-2">{blog.title}</td>
              <td className="p-2">{blog.slug}</td>
              <td className="p-2 flex gap-4 justify-center">
                <button onClick={() => handleEdit(blog)} className="text-blue-600"><FiEdit /></button>
                <button onClick={() => handleDelete(blog.id)} className="text-red-600"><FiTrash2 /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center">
          <div className="bg-white p-6 w-[700px] rounded-lg space-y-4 max-h-[95vh] overflow-y-auto">

            <h3 className="text-lg font-bold">{editingId ? "Edit Blog" : "Add Blog"}</h3>

            <input className="border p-2 w-full" value={title} placeholder="Title" onChange={(e)=>setTitle(e.target.value)} />
            <input className="border p-2 w-full" value={slug} placeholder="Slug" onChange={(e)=>setSlug(e.target.value)} />

            <div className="border rounded p-2">
              <EditorContent editor={editor} className="min-h-[200px]" />
              <button className="mt-2 text-sm text-blue-600 underline" onClick={addImage}>
                + Add Image
              </button>
            </div>

            <input type="file" onChange={(e)=>setBannerFile(e.target.files[0])} className="border p-2 w-full" />

            <div className="flex justify-end gap-3">
              <button onClick={reset} className="px-4 py-2 border rounded">Cancel</button>
              <button onClick={handleSave} className="bg-green-600 text-white px-4 py-2 rounded">
                {editingId ? "Update" : "Save"}
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}
